import { Injectable } from '@angular/core';
import { isNullish } from '@commonHelpers/math-utils';
import { INode } from '@interfaces/iNode';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SoftwarepartnerApiSelectionService {
  private selectedCatalogItemsSubject: BehaviorSubject<INode[]> = new BehaviorSubject<INode[]>([]);

  constructor() { }

  setSelectedCatalogItems(catalogItems: INode[]) {
    // Bugfix https://dev.azure.com/orcacloud/ADE/_workitems/edit/34545/
    // Problem: In der mobilen Ansicht wird der Baum automatisch geschlossen, sobald ein Element ausgewählt wird.
    // Dies triggert den Destruktor, welcher die Methode "sendMarkedNodes" aufruft.
    // 
    // Erwartetes Verhalten: Die aktuell selektierten Elemente sollten an den SoftwarepartnerAPISelectionService übertragen werden.
    // 
    // Tatsächliches Problem: Es entsteht eine Race-Condition zwischen dem Schließen des Baums und dem Senden der Daten.
    // Dies führt dazu, dass anstelle der erwarteten Auswahl der Wert "[undefined]" übertragen wird.
    // 
    // Lösung: Da die Ursache der Race-Condition schwer nachvollziehbar ist, wird 
    // eine Validierung implementiert, die "[undefined]" Werte abfängt und verwirft.

    if(isNullish(catalogItems?.[0])){return}

    this.selectedCatalogItemsSubject.next(catalogItems);
  }

  getAsObservable(): Observable<INode[]> {
    return this.selectedCatalogItemsSubject.asObservable();
  }
}
